import * as React from 'react';

interface IUseInViewOptions {
  threshold?: number | number[];
  root?: Element | null;
  rootMargin?: string;
}

export function useInView<T extends Element = Element>(
  options: IUseInViewOptions = {},
): [React.RefObject<T | null>, boolean] {
  const ref = React.useRef<T>(null);
  const [isInView, setIsInView] = React.useState(true);

  React.useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => setIsInView(entry.isIntersecting), options);

    observer.observe(element);

    return () => {
      /* istanbul ignore else */
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [ref, options]);

  return [ref, isInView];
}
